import { rotuloDaCompetencia } from '../utils/format'
import { rotuloDoVoucherNoExtrato } from '../utils/voucher'

/**
 * #1107 — no extrato da CONTA de crédito, o movimento que veio do voucher (concessão, virada,
 * fim, congelamento, descongelamento) ganha o rótulo e a competência. O resto não ganha nada.
 */
export const RotuloDoVoucherNoExtrato = ({
  referenceType,
  competencia,
}: {
  referenceType: string | null | undefined
  competencia?: string | null
}) => {
  const rotulo = rotuloDoVoucherNoExtrato(referenceType)
  if (!rotulo) return null
  return (
    <span
      className="mt-0.5 inline-flex items-center rounded-full bg-violet-50 px-2 py-0.5 text-xs font-medium text-violet-700"
      data-testid="rotulo-voucher-no-extrato"
    >
      {rotulo}
      {competencia ? ` · ${rotuloDaCompetencia(competencia)}` : ''}
    </span>
  )
}
